/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Third_Title5Inputs */

const en_svc_backend_development_third_title5 = /** @type {(inputs: Svc_Backend_Development_Third_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Third-party integrations`)
};

const ar_svc_backend_development_third_title5 = /** @type {(inputs: Svc_Backend_Development_Third_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تكاملات طرف ثالث`)
};

const bn_svc_backend_development_third_title5 = /** @type {(inputs: Svc_Backend_Development_Third_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`থার্ড-পার্টি ইন্টিগ্রেশন`)
};

const de_svc_backend_development_third_title5 = /** @type {(inputs: Svc_Backend_Development_Third_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrationen von Drittanbietern`)
};

const es_svc_backend_development_third_title5 = /** @type {(inputs: Svc_Backend_Development_Third_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integraciones de terceros`)
};

const fr_svc_backend_development_third_title5 = /** @type {(inputs: Svc_Backend_Development_Third_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégrations tierces`)
};

const pt_svc_backend_development_third_title5 = /** @type {(inputs: Svc_Backend_Development_Third_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrações de terceiros`)
};

const zh_svc_backend_development_third_title5 = /** @type {(inputs: Svc_Backend_Development_Third_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`第三方集成`)
};

const tr_svc_backend_development_third_title5 = /** @type {(inputs: Svc_Backend_Development_Third_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üçüncü taraf entegrasyonları`)
};

const ru_svc_backend_development_third_title5 = /** @type {(inputs: Svc_Backend_Development_Third_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сторонние интеграции`)
};

const pl_svc_backend_development_third_title5 = /** @type {(inputs: Svc_Backend_Development_Third_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integracje z firmami zewnętrznymi`)
};

/**
* | output |
* | --- |
* | "Third-party integrations" |
*
* @param {Svc_Backend_Development_Third_Title5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_third_title5 = /** @type {((inputs?: Svc_Backend_Development_Third_Title5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Third_Title5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_third_title5(inputs)
	if (locale === "bn") return bn_svc_backend_development_third_title5(inputs)
	if (locale === "de") return de_svc_backend_development_third_title5(inputs)
	if (locale === "es") return es_svc_backend_development_third_title5(inputs)
	if (locale === "fr") return fr_svc_backend_development_third_title5(inputs)
	if (locale === "pt") return pt_svc_backend_development_third_title5(inputs)
	if (locale === "zh") return zh_svc_backend_development_third_title5(inputs)
	if (locale === "tr") return tr_svc_backend_development_third_title5(inputs)
	if (locale === "ru") return ru_svc_backend_development_third_title5(inputs)
	if (locale === "pl") return pl_svc_backend_development_third_title5(inputs)
	return en_svc_backend_development_third_title5(inputs)
});
export { svc_backend_development_third_title5 as "svc_backend-development_THIRD_title" }